export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON peacock house CY.6e447613.png";